const NewsCard = ({ tag, title, href, imgSrc }) => {
  return (
    <div className="bg-white border border-gray rounded overflow-hidden flex flex-col shadow-sm shadow-gray">
      <div className="aspect-video overflow-hidden bg-gray">
        <img
          src={imgSrc}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-125"
        />
      </div>
      <div className="p-3 flex flex-col flex-1">
        {tag && (
          <span className="text-primary text-[0.6rem] font-bold tracking-[1.5px] uppercase mb-1.5">
            {tag}
          </span>
        )}
        <p className="text-secondary text-sm font-semibold leading-snug flex-1 mb-2">
          {title}
        </p>
        <a
          href={href}
          className="inline-flex items-center gap-1 text-primary text-[0.72rem] font-semibold border-b border-primary w-fit pb-px"
        >
          Read full story
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  );
};
export default NewsCard;
